import http from 'plugins/axios';

export default {
    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
    addBonus(data) {
        return http.post({
            url: '/admin/zoo/divide/addOrUpdate',
            data,
            dataType: 'form'
        });
    },
    getList(data) {
        return http.get({
            url: '/admin/zoo/divide/getListByPage',
            data
        });
    },
    deleteDivide(data) {
        return http.post({
            url: '/admin/zoo/divide/delete',
            data,
            dataType: 'form'
        });
    }
};